// extracted by mini-css-extract-plugin
module.exports = {"BackgroundColor":"#f9edbc","PrimaryColor":"#1d97c1","HeaderHeight":"60px","header":"_3WUK2","logo":"_1YWCU","nav":"M0J6Y"};